var React = require('react');

function CheckmarkHandrawnInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M38.75 1.248 13.597 37.18a3.668 3.668 0 0 1-5.949.098l-6.398-8.53"}));
}

CheckmarkHandrawnInline.defaultProps = {"fill":"none","viewBox":"0 0 40 40"};

module.exports = CheckmarkHandrawnInline;

CheckmarkHandrawnInline.default = CheckmarkHandrawnInline;
